import { Link } from "react-router-dom";
import { RichText } from "@/components/RichText";
import type { HomeHero } from "@/lib/types";

export default function Hero({ data }: { data: HomeHero }) {
  return (
    <section className="hero">
      <div className="hero-bg" />
      <div className="hero-grid-bg" />
      <div className="hero-inner">
        <div>
          <div className="hero-eyebrow">{data.eyebrow}</div>
          <RichText as="h1" className="hero-title display" html={data.title} />
          <p className="hero-lead">{data.sub}</p>
          <div className="hero-ctas">
            <Link to={data.primaryCta.href} className="btn-primary">
              {data.primaryCta.label}
            </Link>
            <a href={data.secondaryCta.href} className="btn-ghost">
              {data.secondaryCta.label}
            </a>
          </div>
        </div>
        <HeroOrb />
      </div>
    </section>
  );
}

/** The four-agent orchestration diagram that anchors the homepage hero. */
function HeroOrb() {
  return (
    <div className="hero-visual" aria-hidden="true">
      <svg className="orb-svg" viewBox="0 0 560 560">
        <defs>
          <radialGradient id="teal-gradient" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#2DCFC1" />
            <stop offset="60%" stopColor="#17A89E" />
            <stop offset="100%" stopColor="#0B7A75" />
          </radialGradient>
          <linearGradient id="line-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#2DCFC1" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#2DCFC1" stopOpacity="0.15" />
          </linearGradient>
        </defs>

        {/* Pings radiating from center */}
        <circle className="ping" cx="280" cy="280" />
        <circle className="ping ping-2" cx="280" cy="280" />
        <circle className="ping ping-3" cx="280" cy="280" />

        {/* Lines connecting the four agents to the center */}
        <line className="orb-line" x1="280" y1="280" x2="280" y2="100" />
        <line className="orb-line" x1="280" y1="280" x2="460" y2="280" />
        <line className="orb-line" x1="280" y1="280" x2="280" y2="460" />
        <line className="orb-line" x1="280" y1="280" x2="100" y2="280" />

        {/* Agents: top Luna, right AI Front Door, bottom SteerNotes, left Revenue Cycle AI */}
        <g>
          <circle className="orb-agent orb-agent-active" cx="280" cy="100" r="42" />
          <text className="orb-label" x="280" y="104" textAnchor="middle">
            LUNA
          </text>
        </g>
        <g>
          <circle className="orb-agent orb-agent-active" cx="460" cy="280" r="42" />
          <text className="orb-label" x="460" y="278" textAnchor="middle">
            AI FRONT
          </text>
          <text className="orb-label" x="460" y="290" textAnchor="middle">
            DOOR
          </text>
        </g>
        <g>
          <circle className="orb-agent orb-agent-active" cx="280" cy="460" r="42" />
          <text className="orb-label" x="280" y="458" textAnchor="middle">
            STEER
          </text>
          <text className="orb-label" x="280" y="470" textAnchor="middle">
            NOTES
          </text>
        </g>
        <g>
          <circle className="orb-agent orb-agent-active" cx="100" cy="280" r="42" />
          <text className="orb-label" x="100" y="274" textAnchor="middle">
            REVENUE
          </text>
          <text className="orb-label" x="100" y="286" textAnchor="middle">
            CYCLE AI
          </text>
        </g>

        {/* Center: SteerBrain */}
        <circle className="orb-center" cx="280" cy="280" r="58" />
        <text className="orb-center-label" x="280" y="287" textAnchor="middle">
          SteerBrain
        </text>
        <text className="orb-sublabel" x="280" y="368" textAnchor="middle">
          1B+ INTERACTIONS
        </text>
      </svg>
    </div>
  );
}
